/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_English_Level_TitleInputs */

const en_reset_english_level_title = /** @type {(inputs: Reset_English_Level_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset English level`)
};

const de_reset_english_level_title = /** @type {(inputs: Reset_English_Level_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englischkenntnisse zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset English level" |
*
* @param {Reset_English_Level_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const reset_english_level_title = /** @type {((inputs?: Reset_English_Level_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_English_Level_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_reset_english_level_title(inputs)
	return en_reset_english_level_title(inputs)
});